import { HOME_URL } from '@/global/constants/routes'
import { AppLink } from '@/global/components/AppLink'
import { Logo } from '@/global/components/Logo'

export const Header = () => {
  return (
    <div
      data-testid='header'
      className='p-gl-spacing-04 bg-gl-color-shades-white border-b-gl-border-width-xs border-sys-color-stroke-active flex'
    >
      <AppLink
        id='header-logo-link'
        as='link'
        href={HOME_URL}
      >
        <Logo color='on-light' />
      </AppLink>
    </div>
  )
}
